import {
  CheckCircleFilled,
  EditOutlined,
  ExclamationCircleTwoTone,
  EyeInvisibleOutlined,
  RobotOutlined,
} from "@ant-design/icons";
import { Card } from "antd";
import React from "react";
import { ParseMessage } from "~/components/atom/parseMessage.jsx";
import { FlightOpenIcon} from "~/components/flight/FlightOpenIcon.jsx";
import { $t } from "~/i18n.js";
import { _parseDate } from "~/lib/localize.js";
import { colors } from "~/theme/colors.js";
import { HelpBubble } from "../../help/helpBubble.jsx";

export const Notities = ({
  notities,
  dagNotificatie,
  alleenPublic,
  openNotitie,
  currentUserID,
  flightNote = false,
}) => {
  return (
    <div>
      {alleenPublic && (
        <p style={{ marginBottom: 6 }}>
          {notities ? notities.length : 0} {$t("gedeelde notities")}{" "}
          <HelpBubble
            content={$t(
              "Instructeurs kunnen kiezen of ze een notitie met jou willen delen of niet."
            )}
          />
        </p>
      )}
      {notities &&
        notities.length > 0 &&
        notities.map((notitie, key) => {
          const canEdit =
            openNotitie &&
            notitie.instructeur_id === currentUserID &&
            !notitie.is_signature && (
              // edit flight notes only in flight modal, and non-flight notes in profile
              flightNote && notitie.flight_uuid || !flightNote && !notitie.flight_uuid
            );
          return (
            <Card
              key={key}
              size="small"
              className="spacer"
              style={{
                marginBottom: 12,
                borderLeft: notitie.is_kritiek
                  ? `2px solid ${colors.secondary}`
                  : undefined,
              }}
              extra={
                !flightNote && notitie.flight_uuid && 
                  <FlightOpenIcon flight_uuid={notitie.flight_uuid} hideTextOnMobile={true} />
              }
              bodyStyle={{ padding: "0 12px" }}
              title={
                <div className="row">
                  {notitie.is_kritiek && (
                    <ExclamationCircleTwoTone
                      style={{ marginRight: 6 }}
                      twoToneColor="#eb2f96"
                    />
                  )}

                  {!dagNotificatie && (
                    <span
                      className="small"
                      style={{
                        fontWeight: 500,
                        marginRight: 6,
                        color: notitie.is_kritiek
                          ? colors.secondary
                          : colors.darkgray_light,
                      }}
                    >
                      {_parseDate(notitie.datum)}
                    </span>
                  )}

                  <div className="row">
                    <p className="bold small">{notitie.instructeur_naam || <><RobotOutlined style={{marginRight: 4}} />{$t('Systeem')}</>}</p>
                    {notitie.is_signature && (
                      <CheckCircleFilled
                        style={{
                          color: colors.groen_dark,
                          marginLeft: 6,
                        }}
                      />
                    )}
                    {!dagNotificatie && notitie.is_prive && (
                      <span style={{ marginLeft: 6 }}>
                        <EyeInvisibleOutlined />
                      </span>
                    )}
                    {canEdit && (
                      <EditOutlined style={{ marginLeft: 4, fontSize: 12 }} />
                    )}
                  </div>
                </div>
              }
              hoverable={canEdit}
              onClick={() => {
                // only edit if you don't press on the flight Icon button
                canEdit && openNotitie(notitie)

              }}
            >
              <div style={{ marginTop: 0 }}>
                <ParseMessage message={notitie.bericht} />
              </div>
            </Card>
          );
        })}
    </div>
  );
};
